<div class="wrapper">
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <h2>Cashback Report</h2>

        @if ((sessionUser$ | async)?.isAdmin()) {
            <section class="add-section width-50">
                <div>
                    <div class="row">
                        <div class="col-md-6 section-heading">Cashback Wallet Balance</div>
                    </div>
                    <!-- <div class="label-value">
                        <a href="{{ cashbackTokenTransferUrl }}" target="_blank">
                            Blockchain Transactions
                        </a>
                    </div> -->
                    <div class="row">
                        <div class="col-md-4">
                            <small>TOTAL AVAILABLE OFF-CHAIN:</small>
                        </div>
                        <div class="col-md-4">
                            <small>TOTAL AVAILABLE ON-CHAIN:</small>
                        </div>
                        <div class="col-md-4">
                            <small>TOTAL CASHBACKS GIVEN TODAY:</small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 label-value font-size-16">
                            <span>{{ totalOffChainBalance || 0 | currencyFormat }}</span>
                        </div>
                        <div class="col-md-4 label-value font-size-16">
                            <span>{{ totalOnChainBalance || 0 | currencyFormat }}</span>
                        </div>
                        <div class="col-md-4 label-value font-size-16">
                            <span>{{ cashbackTotalToday || 0 | currencyFormat }}</span>
                        </div>
                    </div>
                </div>
            </section>
        }

        <app-filter
            [form]="form"
            [filters]="filters"
            [sessionUser$]="sessionUser$"
            [productFieldKey]="productFieldKey"
            [businessFieldKey]="businessFieldKey"
            [supplierFieldKey]="supplierFieldKey"
            [provinceFieldKey]="provinceFieldKey"
            [wholesalerFieldKey]="wholesalerFieldKey"
            [storeFieldKey]="storeFieldKey"
            [categoryFieldKey]="categoryFieldKey"
            [presetRanges]="presetRanges"
            [showAdvancedFilters]="showAdvancedFilters"
            [searchItems]="searchItems"
            [isClearing]="isClearingFilters"
            (submitSearch)="submit($event)"
            (clear)="clearFilters()"
            (onChangeEvent)="onChange($event.event, $event.key)"
            (onClearEvent)="onClear($event)"
            (toggle)="toggleOption()"
            (removeItem)="removeSearchItem($event.key, $event.item)">
        </app-filter>
        <button class="btn export-btn mb-2" (click)="exportGridToExcel()" [disabled]="isExporting">
            <span
                *ngIf="isExporting"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"></span>
            {{ isExporting ? 'Exporting...' : 'Export to Excel' }}
        </button>

        <ejs-grid
            [dataSource]="cashbackReportList"
            #cashbackReportGrid
            id="cashbackReportGrid"
            rowHeight="38"
            style="margin-top: 10px"
            height="calc(100vh - 410px)"
            [enableHover]="false"
            [enableHeaderFocus]="true"
            [allowSorting]="true"
            [allowFiltering]="true"
            [allowPaging]="true"
            [allowResizing]="true"
            [pageSettings]="pageSettings"
            (excelQueryCellInfo)="onExcelCellInfo($event)"
            allowExcelExport="true"
            [filterSettings]="filterSettings">
            <e-columns>
                <e-column field="fromDate" [visible]="false" width="120"></e-column>
                <e-column field="toDate" [visible]="false" width="120"></e-column>
                <e-column field="cashback" [visible]="false" width="120"></e-column>
                <e-column field="businessUnitIds" [visible]="false" width="120"></e-column>
                <e-column field="productId" [visible]="false" width="120"></e-column>
                <e-column field="provinceId" [visible]="false" width="120"></e-column>
                <e-column field="categoryId" [visible]="false" width="120"></e-column>
                <e-column field="storeId" [visible]="false" width="120"></e-column>
                <e-column field="userRoleId" [visible]="false" width="120"></e-column>
                <e-column field="wholesalerId" [visible]="false" width="120"></e-column>
                <e-column field="id" [visible]="false" width="120"></e-column>
                <e-column field="supplierBusinessUnitId" [visible]="false" width="120"></e-column>
                <e-column field="supplierId" [visible]="false" width="120"></e-column>
                <e-column field="type" [visible]="false" width="120"></e-column>

                <e-column
                    field="orderNumber"
                    headerText="Order Number"
                    width="150"
                    [filter]="{ operator: 'contains' }"></e-column>
                <e-column field="ref" headerText="Invoice Number" width="150"></e-column>
                <e-column
                    field="createdAt"
                    headerText="Date"
                    width="130"
                    format="dd/MMM/yyyy"
                    type="date"
                    width="130">
                    <ng-template #filterTemplate let-data>
                        <ejs-datepicker
                            #createdAtDatePicker
                            [value]="createdAtFilterDate"
                            (change)="onDateFilterChange($event, 'createdAt')"
                            [showClearButton]="true"
                            format="dd/MMM/yyyy"></ejs-datepicker>
                    </ng-template>
                </e-column>
                <e-column field="orderId" headerText="Sale ID" width="150"></e-column>
                <e-column
                    field="supplierName"
                    headerText="Enterprise (Supplier)"
                    width="180"></e-column>
                <e-column field="provinceName" headerText="Province" width="160"></e-column>
                <e-column field="userFullName" headerText="User Name " width="120"></e-column>
                <e-column
                    field="productName"
                    headerText="Product Name"
                    width="190"
                    [filter]="{ operator: 'contains' }"></e-column>
                <e-column field="categoryName" headerText="Category" width="150">
                    <ng-template #template let-data>
                        {{ data.categoryName || '-' }}
                    </ng-template>
                </e-column>
                <e-column field="wholesalerName" headerText="Wholesaler" width="120"></e-column>
                <e-column field="storeName" headerText="Retail Business" width="160"></e-column>
                <e-column
                    field="quantity"
                    headerText="Quantity"
                    type="number"
                    width="130"></e-column>
                <e-column
                    field="netSales"
                    headerText="Nett Sales"
                    type="number"
                    width="150"
                    [allowSorting]="false">
                    <ng-template #template let-data>
                        R{{ data.netSales | number: '1.2-2' }}
                    </ng-template>
                </e-column>
                <e-column
                    field="vat"
                    headerText="Vat"
                    type="number"
                    width="100"
                    [allowSorting]="false">
                    <ng-template #template let-data> R{{ data.vat | number: '1.2-2' }}</ng-template>
                </e-column>
                <e-column
                    field="totalInclusive"
                    headerText="Total Inclusive"
                    width="150"
                    [allowSorting]="false">
                    <ng-template #template let-data>
                        R{{ data.totalInclusive | number: '1.2-2' }}
                    </ng-template>
                </e-column>
                <e-column
                    field="cashback"
                    headerText="Cashback received"
                    width="170"
                    [allowSorting]="false">
                    <ng-template #template let-data>
                        R{{ data.cashback | number: '1.2-2' }}
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>

        <div class="control-sidebar-bg"></div>
    </div>
</div>
